import { render } from "./ServerInfo.vue?vue&type=template&id=296bf962&ts=true"
import script from "./ServerInfo.vue?vue&type=script&lang=ts"
export * from "./ServerInfo.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__